import { useContext, useEffect, useRef, useState } from "react";
import Header from "../components/Header"
import LanguageSet from "../components/language/LanguageSet"
import LanguageContext from "../components/hooks/LanguageContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LoadingSnipQuiz from "../components/LoadingSnipQuiz";
import { ToastContainer, toast } from 'react-toastify';
import Constants from "../common/Constants";
import apiCall, { apiCall2 } from "../api";
import { useAuth } from "../providers/AuthProvider";
import ConsentForm from "./baseline/ConsentForm";
import QuizIntro from "./baseline/QuizIntro";
import VideoSection from "./baseline/VideoSection";
import QuizQuestionSection from "./baseline/QuizQuestionSection";
import { getText } from "../utils/languageUtils";

const BaseLineQuiz = () => {
    const { user, authToken, logout: authLogout,  baseLineId, authDispatch, updateUser } = useAuth(); // Use useAuth
    const navigate = useNavigate();
    const { language, translations: translationData } = useContext(LanguageContext);
console.log(language, translationData);
    const [loading, setLoading] = useState(true);
    const [nextPrevBtnShow, setNextPrevBtnShow] = useState(false);
    const [showVideo, setShowVideo] = useState(true)
    const [data, setData] = useState("")



    const [sectionUrl, setSectionUrl] = useState(null)
    const [question, setQuestion] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalCount, setTotalCount] = useState(0)
    const [selectedOptions, setSelectedOptions] = useState({});
    // const [baseLineId, setBaseLineId] = useState("")
    const [questionId, setQuestionId] = useState("")


    const [, setAnswer] = useState("");
    const [, setIsMarked] = useState(0)
    const [, setFinalSubmit] = useState(false)
    const [optionMarked, setOptionMarked] = useState({})
    const [videoData, setShowVideoData] = useState("")
    const [startQuiz, setStartQuiz] = useState(false)
    const [nextBtnEnable, setNextBtnEnable] = useState(true)


    // State to store the selected age
    const [selectedAge, setSelectedAge] = useState("");
    //Grade List
    const [gradeList, setGradeList] = useState([])
    const [selectedGrade, setSelectedGrade] = useState("");
    // Gender List
    const [selectGender, setSelectedGender] = useState("");

    const [showConsentForm, setShowConsentForm] = useState(user?.is_consent === 0 ? true : false)
    const [consentFormData, setConsentFormData] = useState("");

    const [dataConsent, setDataConsent] = useState(true);
    const [quizStage, setQuizStage] = useState("loading");

    const questionViewStartedAtRef = useRef(null);
    const stayDurationQuestionIdRef = useRef(null);

    useEffect(() => {
        if (quizStage !== "quiz" || !questionId) return;
        if (loading) return;
        if (stayDurationQuestionIdRef.current !== questionId) {
            stayDurationQuestionIdRef.current = questionId;
            questionViewStartedAtRef.current = Date.now();
        }
    }, [questionId, loading, quizStage]);

    const getStayDurationSeconds = () => {
        const start = questionViewStartedAtRef.current;
        if (start == null) return 0;
        return Math.max(0, Math.round((Date.now() - start) / 1000));
    };

    // Event handler for the "Next" button click
    const handleNextClickAge = async (url) => {
        if (selectedAge !== "" && selectedGrade !== "" && selectGender !== "") {
            // Here, you can use the selectedAge value as needed
            // For example, you can submit it to a server or update your application's state.

            // For now, let's log the selected age to the console
            try {
                setLoading(true)
                const formData = new FormData();
                formData.append("age", selectedAge);
                formData.append("grade_id", selectedGrade);
                formData.append("gender_id", selectGender);
                formData.append("access_token", authToken);

                const response = await apiCall({ url: `student-update-age`, method: "POST", data: formData, });

                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {
                    if (response.data.status === 1) {
                        navigate("/baseLineQuiz");
                        let newUrl = `${url}&access_token=${authToken}`;

                        setSectionUrl(newUrl);
                        setQuizStage('quiz')
                    } else if (response.data.status === 2) {

                        toast.error(response?.data?.message);

                    }

                }
            } catch (error) {
                console.error(error);
                toast.warn("An error occurred. Please try again.");
            } finally {
                // Set loading to false when the request is complete
                setLoading(false);
            }

            // Navigate to the next page (e.g., BaseLineQuiz)

        } else {
            // Handle the case where no age is selected
            toast.warn("Please select your age, gender and grade.");
        }
    };



    useEffect(() => {
        const url = `baseline`;
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await apiCall({ url: url, method: "GET" });
                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                    return;
                }

                setData(response.data);
                const baselineId = response.data.baseline_summary.baseline_id;
                authDispatch({ type: "SET_BASELINE_ID", payload: baselineId });
                const totalQuestions = Number(response.data.baseline_summary.total_questions) || 0;

                const getAge = `site/student-age`;

                const response2 = await apiCall({ url: getAge, method: "GET" });
                if (response2.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                    return;
                }

                setSelectedAge(response2.data.student_summary.age)
                setSelectedGrade(Number(response2.data.student_summary.grade))
                setSelectedGender(Number(response2.data.student_summary.gender_id))

                if (user?.is_consent === 0) {
                    setQuizStage('consent')
                } else if (totalQuestions === 0) {
                    // Already consented and no active baseline questions — nothing for the intro/video/quiz to cover, skip straight to completion.
                    await finalSubmitReq(baselineId);
                } else {
                    setQuizStage('video')
                }

            } catch (error) {
                console.error(error);
            } finally {
                // Set loading to false when the request is complete
                setLoading(false);
            }
        }

        fetchData();
    }, [startQuiz, user])


    useEffect(() => {
        const fetchData = async () => {

            let url = `${sectionUrl}&page=${currentPage}`

            try {
                setLoading(true);
                const response = await axios.get(url);

                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                    return;
                }

                if (!response?.data?.baseline_question?.length) {
                    // No baseline questions exist for this baseline (e.g. all removed) — nothing to quiz on, finalize immediately.
                    await finalSubmitReq();
                    return;
                }

                setNextPrevBtnShow(true)
                setQuestion(response.data)
                setTotalCount(response?.data?.summary?.total_page)
                setCurrentPage(response?.data?.summary?.current_page)
                // setBaseLineId(response?.data?.baseline_question[0]?.baseline_id)
                setQuestionId(response?.data?.baseline_question[0]?.id)
                // setHtmlData(HTMLReactParser(response?.data?.baseline_summary?.description[language]));

                let answerUrl = `${Constants.BASE_URL}/baseline-response?access_token=${authToken}&page=${currentPage}&baseline_id=${baseLineId}`;

                const response2 = await axios.get(answerUrl);
                if (response2.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {

                    setIsMarked(response2.data.baseline_question[0].is_marked)
                    setOptionMarked(response2.data.baseline_question[0].option_marked)
                    setFinalSubmit(response2.data.baseline_question[0].is_final_submit)
                    setSelectedOptions(response2.data.baseline_question[0].option_marked)
                    if (response2.data.baseline_question[0].is_marked === 1) {
                        setNextBtnEnable(true)
                    }
                }

            } catch (error) {
                console.error(error);
            } finally {
                // Set loading to false when the request is complete
                setLoading(false);
            }
        }
        if (sectionUrl !== null) {
            fetchData();
        }

    }, [sectionUrl, currentPage])

    const startSection1 = (url) => {
        handleNextClickAge(url);
    }
    const handleOptionChange = (option, index) => {

        setSelectedOptions(option);
        setNextBtnEnable(true)
    };

    const handleNextClick = async () => {
        setNextBtnEnable(false);
        if (!selectedOptions?.id) {
            toast.error("Please select a option");
            setNextBtnEnable(true);
            return;
        }

        if (Number(currentPage) < Number(totalCount)) {
            const stayDuration = getStayDurationSeconds();
            const submitUrl = `${Constants.BASE_URL}/baseline-markasdone?baseline_id=${baseLineId}&baseline_question_id=${questionId}&option_id=${selectedOptions.id}&access_token=${authToken}&stay_duration=${stayDuration}`;

            try {
                setLoading(true);

                const response = await apiCall2({ url: submitUrl, method: "POST" });

                if (response?.data?.message === "Invalid Access Token") {
                    authLogout();
                    navigate("/");
                    return;
                }

                const httpOk =
                    response &&
                    response.status >= 200 &&
                    response.status < 300;
                const success = httpOk && response?.data?.success === true;

                if (success) {
                    setAnswer(response.data);
                    setCurrentPage((p) => Number(p) + 1);
                    setSelectedOptions({});
                } else {
                    toast.error(
                        response?.data?.message ||
                            "Could not save your answer. Please try again."
                    );
                    setNextBtnEnable(true);
                }
            } catch (error) {
                console.error(error);
                const msg =
                    error?.data?.message ||
                    error?.message ||
                    "An error occurred. Please try again.";
                toast.error(msg);
                setNextBtnEnable(true);
            } finally {
                setLoading(false);
            }
        } else if (Number(currentPage) === Number(totalCount)) {
            setFinalSubmit(true);
            setNextBtnEnable(true);
        } else {
            setCurrentPage(1);
            setNextBtnEnable(true);
        }
    };

    const handlePreviousClick = () => {
        if (Number(currentPage) !== 1) {
            setCurrentPage(Number(currentPage) - 1)
        } else if (Number(currentPage) === 1) {
            setCurrentPage(1)
            navigate("/")
        } else {
            setCurrentPage(1)
        }
    }

    useEffect(() => {
        let url = `${Constants.BASE_URL}/baseline-video?access_token=${authToken}`;



        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(url);

                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {

                    setShowVideoData(response.data)
                }
            } catch (error) {
                console.error(error);
            } finally {
                // Set loading to false when the request is complete
                setLoading(false);
            }
        }

        fetchData();
    }, [showVideo, authToken, navigate])


    useEffect(() => {
        let url = `${Constants.BASE_URL}/student-grade-list?access_token=${authToken}`;
        let url2 = `${Constants.BASE_URL}/consent-detail?access_token=${authToken}`;

        const fetchData = async () => {
            try {
                setLoading(true);
                // const response = await axios.get(url);

                const [response, concentDetail] = await Promise.all([
                    axios.get(url),
                    axios.get(url2)
                ])

                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {

                    // setShowVideoData(response.data)
                    setGradeList(response.data.class_summary)
                }

                if (concentDetail.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {
                    setConsentFormData(concentDetail?.data?.consent_summary)
                }

            } catch (error) {
                console.error(error);
            } finally {
                // Set loading to false when the request is complete
                setLoading(false);
            }
        }

        fetchData();
    }, [])

    const renderQuestion = (data) => {

        return (
            <>

                <div className="textBox pb-1 pt-2 position-relative">
                    <div className="shareEmail3 ">

                        <div><p>{getText(data.title, language)}</p></div>
                        <form className="single-type pt-2">
                            <div className="row justify-content-center text-center">
                                {data?.options?.map((option, index) => (
                                    <label key={index}>
                                        <input
                                            type="radio"
                                            name="option"
                                            value={option}
                                            checked={Number(optionMarked.id) === Number(option.id) ? Number(optionMarked.id) === Number(option.id) : Number(selectedOptions.id) === Number(option.id)}
                                            onChange={() => handleOptionChange(option, index)}
                                        />
                                        <span style={{ textAlign: "start" }}>{getText(option.title, language)} </span>

                                    </label>
                                ))
                                }
                            </div>
                        </form>
                    </div>
                </div>

            </>
        )
    }

    const finalSubmitReq = async (baselineIdOverride) => {

        const submitBaselineId = baselineIdOverride ?? baseLineId;

        try {
            const stayDuration = getStayDurationSeconds();
            setLoading(true);
            if (Object.keys(selectedOptions).length > 0) {
                const submitUrl = `${Constants.BASE_URL}/baseline-markasdone?baseline_id=${submitBaselineId}&baseline_question_id=${questionId}&option_id=${selectedOptions.id}&access_token=${authToken}&stay_duration=${stayDuration}`;
                const response = await axios.post(submitUrl);

                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {
                    setSelectedOptions({})
                }
            }

            // Call the second API using data from the first API
            const response2 = await fetch(`${Constants.BASE_URL}/baseline-final-submit?access_token=${authToken}&baseline_id=${submitBaselineId}`);
            const data2 = await response2.json();

            if (data2?.summary?.final_submit_status === 1) {
                authDispatch({ type: "SET_AGE_SUBMITTED", payload: true });
                authDispatch({ type: "SET_BASELINE_QUIZ_COMPLETED", payload: true });
                navigate("/")
            } else {
                toast.error(data2?.summary?.message);
            }
        } catch (error) {
            console.error(error);
            setSelectedOptions({})
        } finally {
            // Set loading to false when the request is complete
            setLoading(false);
        }

    }

    const submitConsentForm = async () => {
        if (dataConsent === false) {
            toast.error("Please select terms and condition.");
            return
        } else if (dataConsent === true) {

            try {
                setLoading(true)
                const url = `${Constants.BASE_URL}/student-consent`;
                const formData = new FormData();
                formData.append("access_token", authToken);
                formData.append("consent", 1);
                const response = await axios.post(
                    url,
                    formData,
                    {
                        headers: {
                            'x-api-key': 'fc9f4a47-4f7f-41ba-a656-d30e0009d6f0',
                            "Access-Control-Allow-Origin": "*"
                        },
                    }
                );


                if (response.data.message === "Invalid Access Token") {
                    authLogout()
                    navigate("/");
                } else {

                    setShowConsentForm(false)
                    updateUser({ is_consent: 1 })

                    if (Number(data?.baseline_summary?.total_questions) > 0) {
                        setQuizStage('video');
                    } else {
                        // No active baseline questions — nothing for the video/intro/quiz to cover, skip straight to completion.
                        await finalSubmitReq(data?.baseline_summary?.baseline_id);
                    }
                }
            } catch (error) {
                console.error(error);
                toast.warn("An error occurred. Please try again.");
            } finally {
                // Set loading to false when the request is complete
                setLoading(false);
            }
        }


    }

    const renderItem = () => {
        switch (quizStage) {
            case "consent":
                return <ConsentForm
                    consentFormData={consentFormData}
                    dataConsent={dataConsent}
                    setDataConsent={setDataConsent}
                    submitConsentForm={submitConsentForm}
                    language={language}
                    translationData={translationData}
                />
            case "intro":
                return <QuizIntro
                    data={data}
                    gradeList={gradeList}
                    selectedGrade={selectedGrade}
                    setSelectedGrade={setSelectedGrade}
                    selectGender={selectGender}
                    setSelectedGender={setSelectedGender}
                    language={language}
                    startSection1={startSection1}
                    translationData={translationData}
                />
            case "video":
                return <VideoSection
                    videoData={videoData}
                    language={language}
                    setQuizStage={setQuizStage}
                    setStartQuiz={setStartQuiz}
                    translationData={translationData}
                />
            case "quiz":
                return (
                    <>
                        {loading && <LoadingSnipQuiz />}
                        <QuizQuestionSection
                            question={question}
                            handleNextClick={handleNextClick}
                            handlePreviousClick={handlePreviousClick}
                            selectedOptions={selectedOptions}
                            nextBtnEnable={nextBtnEnable}
                            currentPage={currentPage}
                            totalCount={totalCount}
                            finalSubmitReq={finalSubmitReq}
                            renderQuestion={renderQuestion}
                            loading={loading}
                            language={language}
                            optionMarked={optionMarked}
                            handleOptionChange={handleOptionChange}
                            translationData={translationData}
                        />
                    </>
                );
            default:
                return <LoadingSnipQuiz />;
        }
    }

    return (
        <>
            <div id="body_bg">
                {user && (
                    <Header
                        page_title={
                            (getText(user?.student_name, language) || "") + " (" + user?.student_id + ")"
                        }
                        pageTitle="AskAge"
                    />
                )}

                <LanguageSet pageTitle={"AskAge"} />
                {renderItem(quizStage)}

                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </div >
        </>
    )
}

export default BaseLineQuiz